import { appendRefMarkers, CurrentStageAndConfig, getCurrentStageAndConfig  } from "@amzn/rangoli-seller-desktop-async-call-wrapper/src/index";
import { ErrorMessages, handleOpenToaster, toasterData } from "@amzn/rangoli-seller-desktop-utils/src/index";
import { useMutation } from "react-query";

import { Endpoints } from '../../enums/Endpoints';
import { smartposUrl } from "../ApiClient";

const { ERROR_SCREEN_HEADER } = ErrorMessages;

const usePostMerchantRegisterMutation = () => {
  return useMutation<any, Error>(postMerchantRegisterApi);
};
export const postMerchantRegisterApi = async () => {
  const {config: currentStage}: CurrentStageAndConfig = getCurrentStageAndConfig();

  const authPortalUrlReq = {
    domain: currentStage.domain,
    associationHandle: currentStage.associationHandle,
    returnToUrl: appendRefMarkers(currentStage.returnToUrlOnboarding),
    pageId: currentStage.pageId,
  };

  const authHeaders = {
    AuthPortalUrlRequest: JSON.stringify(authPortalUrlReq),
  };

  try {
    const response = (
      await smartposUrl.post(
        `${Endpoints?.merchantRegister}`,
        {},
        {
          headers: authHeaders,
        }
      )
    ).data;

    return response;
  } catch (error) {
    handleOpenToaster({...toasterData, text: ERROR_SCREEN_HEADER});
  }
};

export default usePostMerchantRegisterMutation;
